// removed by extract-text-webpack-plugin
module.exports = {"container":"LQjJp","error":"_1wsDM","info":"_1E5Pi","center":"_11-FA","close":"u7KRr"};


//////////////////
// WEBPACK FOOTER
// ./app/components/message/message.scss
// module id = 1061
// module chunks = 0 3 5 6